<template>
  <div class="container-ranked" :class="{mobile: isMobile}">
    <div class="top-left color-block flex justify-center items-center">
      <img class="max-h-full max-w-full" loading="lazy" src="https://api.baranimes.com/images/avatar_users/tttt.webp" />
    </div>
    <div class="bottom-right color-block flex justify-center items-center">
      <img
        class="max-h-full max-w-full"
        loading="lazy"
        src="https://api.baranimes.com/images/avatar_users/64ff2f678d4434.65027409.png"
      />
    </div>

    <div class="vs-container-ranked">
      <div class="vs" @click="animate">VS</div>
      <div class="lightning" :class="{active: isAnimating}">
        <svg viewBox="0 0 24 24">
          <path d="M7 2v11h3v9l7-12h-4l4-8H7z" />
        </svg>
      </div>
    </div>
    <div class="counter-container-ranked">
      <div>La partie commence dans :</div>
      <div class="counter flex justify-center">15</div>
    </div>
  </div>
</template>

<script setup>
  import {ref, onMounted, onBeforeUnmount} from "vue";

  const isMobile = ref(false);
  const isAnimating = ref(false);

  const checkMobile = () => {
    isMobile.value = window.innerWidth <= 768;
  };

  const animate = () => {
    isAnimating.value = true;
    setTimeout(() => {
      isAnimating.value = false;
    }, 500);
  };

  onMounted(() => {
    checkMobile();
    window.addEventListener("resize", checkMobile);
  });

  onBeforeUnmount(() => {
    window.removeEventListener("resize", checkMobile);
  });
</script>

<style scoped>
  .container-ranked {
    position: relative;
    width: 100vw;
    height: 100vh;
    display: flex;
    overflow: hidden;
  }

  .color-block {
    flex: 1;
    transition: all 0.3s ease;
  }

  .top-left {
    background: url(https://api.baranimes.com/images/global/bg_avatar.webp) 0 0 / cover,
      linear-gradient(#8585ff, #223255);
  }

  .bottom-right {
    background: url(https://api.baranimes.com/images/global/bg_avatar.webp) 0 0 / cover,
      linear-gradient(#e8708c, #521515);
  }

  .vs-container-ranked {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
  }
  .counter-container-ranked {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 2;
  }
  .vs {
    font-size: 8rem;
    font-weight: bold;
    color: white;
    text-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
    cursor: pointer;
    user-select: none;
    animation: pulse 3s infinite;
  }
  .counter {
    font-size: 8rem;
    font-weight: bold;
    color: white;
    text-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
    cursor: pointer;
    user-select: none;
  }
  .lightning {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 200px;
    height: 200px;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  .lightning.active {
    opacity: 1;
  }

  .lightning svg {
    width: 100%;
    height: 100%;
    fill: gold;
    filter: drop-shadow(0 0 10px gold);
  }

  .mobile .top-left {
    position: absolute;
    width: 100%;
    height: 50%;
    top: 0;
  }

  .mobile .bottom-right {
    position: absolute;
    width: 100%;
    height: 50%;
    bottom: 0;
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }

  @media (max-width: 768px) {
    .container-ranked {
      flex-direction: column;
    }

    .vs {
      font-size: 5rem;
    }

    .lightning {
      width: 150px;
      height: 150px;
    }
  }
</style>
